import { render, staticRenderFns } from "./TableForm9.vue?vue&type=template&id=21787ce5&scoped=true"
import script from "./TableForm9.vue?vue&type=script&lang=ts"
export * from "./TableForm9.vue?vue&type=script&lang=ts"
import style0 from "./TableForm9.vue?vue&type=style&index=0&id=21787ce5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21787ce5",
  null
  
)

export default component.exports